var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.type,
    _vm._g(
      _vm._b(
        {
          ref: "pageLayout",
          tag: "component",
          staticClass: "PageLayout",
          attrs: { "slot-arr": _vm.slotArr },
          scopedSlots: _vm._u(
            [
              _vm._l(_vm.slotArr, function (item, i) {
                return {
                  key: item,
                  fn: function (text, record, index) {
                    return [
                      _c(
                        "div",
                        { key: `table-${i}` },
                        [
                          _vm._t(
                            item,
                            null,
                            { row: text.row, record: record, index: index },
                            _vm.$attrs
                          ),
                        ],
                        2
                      ),
                    ]
                  },
                }
              }),
            ],
            null,
            true
          ),
        },
        "component",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }